import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./modules/user";
import pageReducer from "./modules/page";

export default configureStore({
  reducer: {
    user: userReducer,
    page: pageReducer,
  },
});
